import createSelector from '../../utils/reselect';

const meetingStateData = (state) => {
  const { meetings } = state;
  return meetings || [];
};

export const allMeetings = createSelector(meetingStateData, (meetings) => meetings.get('meetings') || []);

export const getMeeting = createSelector(meetingStateData, (meetings) => meetings.get('meeting') || {});

export const getLoading = createSelector(meetingStateData, (meetings) => meetings.get('loading'));

export const meetingRegisteries = createSelector(meetingStateData, (meetings) => meetings.get('meetingRegisteries'));

export const registeryPagination = createSelector(meetingStateData, (meetings) => meetings.get('registeryPagination'));

export const meetingReportLoading = createSelector(meetingStateData, (meetings) => meetings.get('meetingReportLoading'));

export const meetingReport = createSelector(meetingStateData, (meetings) => meetings.get('meetingReport'));
